import { Chip, chipClasses, Tooltip } from '@mui/material';
import { OrgIcon } from '@/shared/ui';

export function SharedPresetChip() {
  return (
    <Tooltip
      arrow
      title="Shared with you by another member of your organization. You can view and use it, but only the owner can edit, delete, or unshare it."
    >
      <Chip
        sx={{
          height: 22,
          [`& .${chipClasses.label}`]: {
            pr: 0,
          },
        }}
        icon={<OrgIcon sx={{ width: 12, height: 12 }} />}
      />
    </Tooltip>
  );
}
